<script>
  import AccordionGroup from "../Components/Accordion/AccordionGroup.svelte";
  import AccordionItem from "../Components/Accordion/AccordionItem.svelte";

  export let title, parentId;
</script>

<AccordionGroup {title} {parentId}>
  <AccordionItem>
    <div slot="header">
      Can I search for my receipt if I renewed at the Office of Motor Vehicle?
    </div>
    <div slot="content">
      No, you can only review Renewal Receipts for renewals made online from
      October 1, 2013 going forward.
    </div>
  </AccordionItem>
  <AccordionItem>
    <div slot="header">
      Will I be able to review my Renewal Receipt from the previous year?
    </div>
    <div slot="content">
      You will be able to review any Renewal Receipt for online renewals made
      after October 1, 2013.
    </div>
  </AccordionItem>
</AccordionGroup>
